import i18n from "i18n";

// siteUrl should be '/key', where key is the key of the location in the locations object
// this is because MainPage bases on the location param to render the correct location

export const getLocations = () => {
  return {
    wroclaw: {
      title: "WROCŁAW",

      // site data
      bookingUrl: {
        eng: "https://xl.plan4u.pl/pixel/xl/bookItNEW_EN.html",
        pl: "https://xl.plan4u.pl/pixel/xl/bookItNEW_PL.html",
      },
      plan4uApiUrl: "https://xl.plan4u.pl/pixel/xl/api/v1",
      siteUrl: "/wroclaw",
      siteTitle: "Pixel XL Wroclaw",
      arenaWithCredits: false,
      googleMapsOptions: {
        latitude: 51.10697301550853,
        longitude: 17.03222937059691,
        zoom: 15,
      },
      prices: {
        smallGroupLowerPrice: "35",
        smallGroupHigherPrice: "50",
        bigGroupLowerPrice: "30",
        bigGroupHigherPrice: "45",
        arenaLowerPrice: "20",
        arenaHigherPrice: "30",
      },
      aboutUsImages: [
        "/images/wroclaw/about-us/about-picture-1.jpg",
        "/images/wroclaw/about-us/about-picture-2.jpg",
        "/images/wroclaw/about-us/about-picture-3.jpg",
        "/images/wroclaw/about-us/about-picture-4.v2.jpg",
        "/images/wroclaw/about-us/about-picture-5.jpg",
        "/images/wroclaw/about-us/about-picture-6.jpg",
      ],
      aboutUsMobileImages: [
        "/images/wroclaw/about-us/mobile-about-picture-1.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-3.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-4.v2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-5.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-6.jpg",
      ],
      documents: {
        pl: {
          companies: "/documents/wroclaw/companies-v4.pdf",
          schools: "/documents/wroclaw/schools-v6.pdf",
          birthdays: "/documents/wroclaw/birthday-v5.pdf",
        },
        eng: {
          companies: "/documents/wroclaw/companies-eng-v3.pdf",
          schools: "/documents/wroclaw/schools-eng-v3.pdf",
          birthdays: "/documents/wroclaw/birthday-eng-v3.pdf",
        },
      },
      address: "Świdnicka 12, 50-068 Wrocław",
      email: "wroclaw@pixel-xl.com",
    },
    katowice: {
      title: "KATOWICE",
      label: i18n.t("locationsPage.openNow"),
      openingDate: new Date("2024-06-04T09:00:00"),

      // site data
      siteUrl: "/katowice",
      bookingUrl: {
        eng: "https://xl.plan4u.pl/pixel/katowice/bookItNEW_EN.html",
        pl: "https://xl.plan4u.pl/pixel/katowice/bookItNEW_PL.html",
      },
      plan4uApiUrl: "https://xl.plan4u.pl/pixel/katowice/api/v1",
      siteTitle: "Pixel XL Katowice",
      arenaWithCredits: true,
      googleMapsOptions: {
        latitude: 50.262872,
        longitude: 19.020316,
        zoom: 16,
      },
      prices: {
        smallGroupLowerPrice: "31",
        smallGroupHigherPrice: "45",
        bigGroupLowerPrice: "27",
        bigGroupHigherPrice: "40",
        arenaLowerPrice: "25",
        arenaHigherPrice: "35",
      },
      aboutUsImages: [
        "/images/wroclaw/about-us/about-picture-1.jpg",
        "/images/katowice/about-us/about-picture-2.v2.jpg",
        "/images/wroclaw/about-us/about-picture-3.jpg",
        "/images/katowice/about-us/about-picture-4.png",
        "/images/wroclaw/about-us/about-picture-5.jpg",
        "/images/katowice/about-us/about-picture-6.png",
      ],
      aboutUsMobileImages: [
        "/images/wroclaw/about-us/mobile-about-picture-1.jpg",
        "/images/katowice/about-us/mobile-about-picture-2.v2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-3.jpg",
        "/images/katowice/about-us/mobile-about-picture-4.png",
        "/images/wroclaw/about-us/mobile-about-picture-5.jpg",
        "/images/katowice/about-us/mobile-about-picture-6.png",
      ],
      documents: {
        pl: {
          companies: "/documents/katowice/companies.pdf",
          schools: "/documents/katowice/schools.pdf",
          birthdays: "/documents/katowice/birthday.pdf",
        },
        eng: {
          companies: "/documents/katowice/companies.pdf",
          schools: "/documents/katowice/schools.pdf",
          birthdays: "/documents/katowice/birthday.pdf",
        },
      },
      address: "Sokolska 31, 40-086 Katowice",
      email: "katowice@pixel-xl.com",
    },
  };
};
